import { CLUSTER_API } from '../API/BASE_URL';

export const getResident = async (id) => {
  const response = await fetch(CLUSTER_API + `residents/${id}`, {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
